<template>
  <v-card>
<!--    <v-card-title>Current Student : {{ register.student.teacherId }} -  {{ register.student.username }}</v-card-title>-->
    <v-card-text>
      <slot name="body">
        <v-textarea
            counter
            row-height="20"
            rows="8"
            :messages="textData.length > maxLength ? 'Feedback is too long' : ''"
            :value="textData"
            v-model="textData"
            @change="submit"
        />
      </slot>
    </v-card-text>
    <v-card-actions class="justify-end mr-2 pb-4">
      <v-btn color="amber" dark rounded small @click="$emit('hide')">
        Close(취소)
      </v-btn>
      <v-btn color="success" rounded small @click="submit" :disabled="textData.length > maxLength">
        Submit(확인)
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: 'PopupTextEditor',
  components: {},
  props: {
    textData: {type: String, default: '',},
  },
  data(){
    return {
      listLoading: true,
      maxLength: 890,
      context: ''
    }
  },
  computed: {
    ...mapGetters(['app','user','teacherList'])
  },
  created() { },
  mounted() {},
  methods: {
    submit(){
      this.$emit('submit', this.textData)
    }
  }
}
</script>

<style scoped>
.pagination-container {
  padding: 32px 16px;
}
.pagination-container.hidden {
  display: none;
}
</style>
